import React from 'react';
import './Team.css';


const Team = () => {
  return (
    <div className="team-container">
      <h1>Equipo</h1>
      <div className="main-image">
        <img className="rodrigo" src="RODRIGO_new.jpg" alt="rodrigojana" />
        <div className="main-image-text">
          <h3>Rodrigo Jana Linetzky</h3>
          <h6>Abogado titulado de la Universidad de Chile año 1994</h6>
          <h6>Miembro del Colegio de Abogados de Chile A.G.</h6>
        </div>
      </div>
      <div className="abogadas">
        <div className="abogada1">
          <img className="macarena" src="MACARENA_new.jpg" alt="macarena" />
          <div className="abogada1-text">
            <h3>Macarena Hermosilla</h3>
            <h6>Abogada titulada de la Universidad de Los Andes, con máxima distinción.</h6>
            <h6>Recibió su título de abogada otorgado por la Corte Suprema el día 26 de febrero de 2015.</h6>
            <h6>Ingresó a Jana Abogados el año 2015.</h6>
            <h6>Diplomado Derecho de la Infancia Universidad de Los Andes 2023.</h6>
            <h6>Su práctica se enfoca en todas las áreas complejas del Derecho de Familia negociaciones y litigios.</h6>
            <h6>Es miembro de la Asociación de Abogados de Familia de Chile y del Colegio de Abogados.</h6>
          </div>
        </div>
        <div className="abogada2">
          <img className="" src="GABRIELA_new.jpg" alt="gabriela" />
          <div className="abogada2-text">
            <h3>Gabriela Wacquez</h3>
            <h6>Abogada titulada de la Universidad de los Andes.</h6>
            <h6>Recibió su título ante la Excma. Corte Suprema el día 18 de diciembre de 2015.</h6>
            <h6>Ingresó a Jana Abogados el año 2022.</h6>
            <h6>Diplomado de Derecho de Familia Instituto de Estudios Judiciales año 2025.</h6>
            <h6>Su práctica se enfoca en todas las áreas del Derecho de Familia, negociaciones y litigios.</h6>
            <h6>Es miembro de la Asociación de Abogados de Familia de Chile y del Colegio de Abogados.</h6>
          </div>
        </div>
        <div className="abogada3">
          <img className="anita" src="ANITA_new.jpg" alt="anita" />
          <div className="abogada3-text">
            <h3>Anita María Araya</h3>
            <h6>Abogada titulada de la Universidad Adolfo Ibáñez.</h6>
            <h6>Recibió su título de Abogada otorgado por la Excma. Corte Suprema el día 22 de diciembre del año 2022.</h6>
            <h6>Ingresó a Jana Abogados el año 2023.</h6>
            <h6>Su práctica se enfoca en todas las áreas del Derecho de Familia, negociaciones y litigios.</h6>
          </div>
        </div>
        <div className="abogada4">
          <img className="fernanda" src="FERNANDA_new.jpg" alt="fernanda" />
          <div className="abogada4-text">
            <h3>Fernanda Gassmann</h3>
            <h6>Abogada titulada de la Universidad de Chile 2025.</h6>
            <h6>Recibió su título de Abogada otorgado por la Excma. Corte Suprema el día 29 de octubre del año 2025.</h6>
            <h6>Ingresó a Jana Abogados el año 2025.</h6>
            <h6>Su práctica se enfoca en todas las áreas del Derecho de Familia, negociaciones y litigios.</h6>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team; 